// extracted by mini-css-extract-plugin
export var measureBox = "_83-0";